import { useProfileLang } from 'shared/hooks/profile.hooks';

/**
 * AG Grid cell renderer that translates profile option keys to display labels.
 *
 * @param {import('ag-grid-community').ICellRendererParams & {
 *   multiple?: boolean
 * }} params
 */
export function TranslatedCell({ value, multiple = false }) {
  const { getValueFromLang, getMultipleValuesFromLang } = useProfileLang();

  if (multiple) {
    return getMultipleValuesFromLang(value);
  }

  return getValueFromLang(value);
}
